(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components'; // TODO: Move to containers

var StyledFooter = styled('footer').withConfig({
  displayName: "Footer__StyledFooter",
  componentId: "sc-178vvru-0"
})(["background:#293440;color:#fff;padding:50px;text-align:center;"]);

var _default = function _default(props) {
  var children = props.children,
      className = props.className;
  return React.createElement(StyledFooter, {
    className: className
  }, children);
};

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledFooter, "StyledFooter", "/home/vsts/work/1/s/src/components/layout/Footer.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/layout/Footer.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();